import React, { useEffect } from "react";
import AgoraRTM from "agora-rtm-sdk";
import { RtmRole } from "agora-access-token";
import { getPrivilegeExipryRTM } from "../../../util/helpers";
import { getToken } from "./AgoraMethods";

const DummyClient = () => {
  //! THIS IS FOR CHAT RTM TESTING PURPOSES ONLY
  const client = AgoraRTM.createInstance(process.env.REACT_APP_AGORA_ID);
  const uid = "650";
  const role = RtmRole.Rtm_User;
  const privilegeExpriyTime = getPrivilegeExipryRTM();
  const token = getToken(
    process.env.REACT_APP_AGORA_ID,
    process.env.REACT_APP_AGORA_CERTIFICATE,
    uid,
    role,
    privilegeExpriyTime
  );

  useEffect(() => {
    const connect = async () => {
      await client.login({ uid, token: token });
      window.clientAgora = client;
      client.on("MessageFromPeer", (message, peerID) => {
        console.log(`${peerID} texted :`, message);
      });
    };
    connect();

    return () => {
      const disconnect = async () => {
        await client.logout();
      };
      try {
        disconnect();
      } catch (e) {}
    };
  }, []);

  const sendMessageToClinician = (uid) => {
    const now = new Date();
    clientAgora
      .sendMessageToPeer(
        { text: `Sending as abhishek to clinician 82 ${now}` },
        uid
      )
      .then((sendResult) => {
        if (sendResult.hasPeerReceived) {
          console.log("Clinician has recieved the message!");
        } else {
          console.log(
            "Message sent but clinician has not recieved the message!"
          );
        }
      })
      .catch((error) => {
        console.log(
          `Error sending message to clinician 82 as client ${uid}`,
          error
        );
      });
  };
  return (
    <>
      {window.location.origin === "http://localhost:3000" && (
        <button
          onClick={() => {
            sendMessageToClinician("82");
            sendMessageToClinician("82chat");
            sendMessageToClinician("82patients");
          }}
        >
          Send mesage client
        </button>
      )}
    </>
  );
};

export default DummyClient;
